import { LineChart } from '@client/app/modules/charts/models/charts/line';
import { Injectable } from '@angular/core';
import { LegendCursorService } from '@client/app/modules/charts/services/LegendCursor.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';

class QaSpellcheckLineChart {
    lineChartSettings = new LineChart();

    constructor (
        private readonly pipeService: PipeService,
        private readonly translateService: TranslateService,
        private readonly dateTimeService: DateTimeService,
        private readonly legendCursorService: LegendCursorService,
    ) {}
    /**
     * @memberOf QASpellcheckLineChartService
     * @description The option object for the QA spellcehck line chart
     */
    getOption () {
        this.lineChartSettings.setTooltipSettings({
            enabled: true,
            mode: 'x-axis',
            bodySpacing: 5,
        });
        this.lineChartSettings.setLegendSettings(true, 'bottom');
        this.lineChartSettings.setScalesSettings({
            xAxes: [
                {
                    id: 'x-axis-0',
                    gridLines: {
                        display: false,
                    },
                },
            ],
            yAxes: [
                {
                    id: 'y-axis-0',
                    type: 'linear',
                    display: true,
                    position: 'left',
                    ticks: {
                        beginAtZero: true,
                        suggestedMax: 4,
                        maxTicksLimit: 5,
                        callback: (value) => {
                            return this.pipeService.get('monNumber')(value);
                        },
                        min: 0,
                    },
                },
            ],
        });
        this.lineChartSettings.setHoverSettings({
            mode: 'x-axis',
        });
        this.lineChartSettings.options = this.legendCursorService.setHoverState(this.lineChartSettings.options);
        return this.lineChartSettings.options;
    }

    /**
     * @memberOf QASpellcheckLineChartService
     * @description The colors for the QA spellcehck line chart
     */
    getColors () {
        this.lineChartSettings.addColors(['#fcb785', '#9ac6df']);
        return this.lineChartSettings.colors;
    }

    /**
     * @memberOf QASpellcheckLineChartService
     * @description The series for the QA spellcehck line chart
     */
    getSeries () {
        this.lineChartSettings.addSeries([
            this.translateService.getString('Unique misspellings'),
            this.translateService.getString('Potential misspellings'),
        ]);
        return this.lineChartSettings.series;
    }

    /**
     * @memberOf QASpellcheckLineChartService
     * @description The override object for the QA spellcehck line chart
     */
    getOverride () {
        this.lineChartSettings.addOverrides([
            {
                xAxisID: 'x-axis-0',
                yAxisID: 'y-axis-0',
                fill: false,
            },
            {
                xAxisID: 'x-axis-0',
                yAxisID: 'y-axis-0',
                fill: false,
            },
        ]);
        return this.lineChartSettings.override;
    }

    /**
     * @memberOf QASpellcheckLineChartService
     * @description The labels for the QA spellcehck line chart
     */
    getLabels (crawls) {
        return crawls.map((crawl) => {
            return this.dateTimeService.format(crawl.date, 'MMM DD');
        });
    }

    /**
     * @memberOf QASpellcheckLineChartService
     * @description The data object for the QA spellcehck line chart
     */
    getData (crawls) {
        return [
            crawls.map((crawl) => {
                return crawl.spelling_errors_confirmed_count || 0;
            }),
            crawls.map((crawl) => {
                return crawl.spelling_errors_potential_count || 0;
            }),
        ];
    }
}

@Injectable({
    providedIn: 'root',
})
export class QASpellcheckLineChartService {
    constructor (
        private readonly pipeService: PipeService,
        private readonly translateService: TranslateService,
        private readonly dateTimeService: DateTimeService,
        private readonly legendCursorService: LegendCursorService,
    ) {}

    init () {
        return new QaSpellcheckLineChart(
            this.pipeService,
            this.translateService,
            this.dateTimeService,
            this.legendCursorService,
        );
    }


}
